module.exports = __webpack_public_path__ + "img/sand-transition.ff6a0510.png";